// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/bars-3.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/bars-3'

import { Icon, type IconComponentProps } from '../icon'

export const Bars3Icon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
